import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'variant',
})(({ theme, variant }) => ({
  marginBottom: theme.spacing(2),
  '&& .MuiAlert-root': {
    alignItems: 'center',
    color: theme.palette.common.white,
    backgroundColor:
      variant === 'dark'
        ? theme.palette.notice.backgroundDark
        : theme.palette.notice.background,
    ...(variant === 'dark' && {
      borderLeft: '4px solid',
      borderLeftColor: theme.palette.error.main,
    }),
  },
  '&& .MuiAlert-icon': {
    color: theme.palette.error.main,
  },
  '&& .MuiAlert-message': {
    ...theme.typography.body2,
    color: theme.palette.common.white,
    lineHeight: '145%',
  },
}));

export const StyledLink = styled('a')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.common.white,
  fontWeight: 700,
  lineHeight: '145%',
  textDecoration: 'underline',
  textUnderlinePosition: 'from-font',
}));

export default StyledWrapper;
